import { httpClient } from './httpClient';

export interface Notification {
  id: number;
  type: string;
  ticket_id: number;
  ticket_title?: string;
  ticket_status?: string;
  read: boolean;
  created_at: string;
  message: string;
  createdAt?: string;
}

export interface NotificationResponse {
  notifications: Notification[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
  limit: number;
}

export interface NotificationQueryParams {
  page?: number;
  limit?: number;
  read?: boolean;
}

export const notificationService = {
  getNotifications: async (params: NotificationQueryParams = {}): Promise<NotificationResponse> => {
    return httpClient.get<NotificationResponse>('/api/notifications', { params });
  },

  markAsRead: async (notificationId: string | number): Promise<void> => {
    return httpClient.put(`/api/notifications/${notificationId}/read`, {});
  },

  markAllAsRead: async (): Promise<void> => {
    // Fix the endpoint to match what the server expects
    return httpClient.put('/api/notifications/mark-all-read', {});
  }
};
